
















































































































































































import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { checkPermissions } from '@/directives/permissionDirective'
import { ADMColumn } from '@/interfaces/adm-columns.interface'
import { Filter } from '@/interfaces/filter.interface'
import { APIPagination } from '@/models/api/pagination.model'
import moment from 'moment'
import { Component, Vue, Watch } from 'vue-property-decorator'
import BulkUnsubscriptionForm from './BulkUnsubscriptionForm.vue'
import BulkUnsubscriptionList from './BulkUnsubscriptionList.vue'

@Component({
    components: {
        ConfirmDialog,
        BulkUnsubscriptionList,
        BulkUnsubscriptionForm
    }
})
export default class BulkUnsubscriptions extends Vue {
    loading = false;
    mainTitle = 'Bulk Unsubscriptions';
    filters: Filter[] = [];
    dateFilter: string[][] = [];
    filterList: Filter[] = [];
    selectedRows = [];
    selectRows = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any[] = [];
    rowsPerPage = 15;
    permissionPrefix = 'bulk-unsubscriptions';

    sortBy = ''
    sortByDesc = false

    pagination: APIPagination = {
        currentPage: 1,
        total: 0,
        nextPage: null,
        previousPage: null
    };

    uploadFromFile = {
        active: false,
        mode: 'Add',
        valid: false,
        uploadfile: null,
        bulkUnsubscriptionTotalSubscription: null
    };

    chipFile = false;

    customColums: ADMColumn[] = [];
    columns: ADMColumn[] = [
        {
            text: 'ID',
            value: 'bulkUnsubscriptionId'
        },
        {
            text: 'Description',
            value: 'bulkUnsubscriptionDescription'
        },
        {
            text: 'Subscriptions',
            value: 'bulkUnsubscriptionTotalSubscription'
        },
        {
            text: 'Created By',
            value: 'userId.username'
        },
        {
            text: 'Processed at',
            value: 'bulkUnsubscriptionProcessedAt',
            customField: {
                type: 'date'
            }
        },
        {
            text: 'Processed By',
            value: 'bulkUnsubscriptionProcessedBy.username'
        },
        {
            text: 'Status',
            value: 'bulkUnsubscriptionStatus'
        },
        {
            text: 'Actions',
            width: '100px',
            customField: {
                type: 'options',
                hideAll: false
            }
        }
    ];

    statementEdit = {};

    @Watch('filters')
    onFiltersChange () {
        if (this.filters.length === 0) this.filterHandler()
    }

    // METHODS

    checkPendings () {
        const pendings = this.data.filter(x => x.bulkUnsubscriptionStatus === 'pending')
        return pendings.length > 0
    }

    checkPermision (permission: string) {
        return !!checkPermissions(permission)
    }

    addFilter () {
        this.filters.push(JSON.parse(JSON.stringify(this.filterList[0])))
        this.dateFilter.push([])
    }

    removeFilter (filterIndex: number) {
        this.filters = this.filters.filter(
            (filter, index) => index !== filterIndex
        )
        this.dateFilter = this.dateFilter.filter(
            (filter, index) => index !== filterIndex
        )
        this.$forceUpdate()
    }

    updateFilter (index: number, newFilter: string) {
        const foundFilter = this.filterList.find(
            filter => filter.value === newFilter
        )
        if (foundFilter) {
            this.filters[index] = JSON.parse(JSON.stringify(foundFilter))
        }
        this.$forceUpdate()
    }

    newLimitHandler (val: number) {
        this.rowsPerPage = val
        this.pagination = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null
        }
        this.loadData()
    }

    paginationTable (val: number) {
        this.pagination.currentPage = val
        this.loadData()
    }

    getMonthNow () {
        return moment()
            .format('YYYY-MM')
            .toString()
    }

    filterHandler () {
        this.pagination = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null
        }
        this.loadData()
    }

    closeModal () {
        this.statementEdit = {}
        this.uploadFromFile.active = false
    }

    createField () {
        this.statementEdit = {}
        this.uploadFromFile.active = true
        this.uploadFromFile.mode = 'Add'
        this.uploadFromFile.uploadfile = null
        this.chipFile = false
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editField (field: any) {
        this.statementEdit = field
        this.uploadFromFile.active = true
        this.uploadFromFile.mode = 'Edit'
        this.uploadFromFile.uploadfile = null
        this.chipFile = true
    }

    get userData () {
        return this.$store.state.AuthStore.auth.user
    }

    getFilters () {
        this.filterList.push(
            {
                text: 'Description',
                type: 'text',
                value: 'bulkUnsubscriptionDescription',
                queryValue: ''
            },
            {
                text: 'Status',
                type: 'text',
                value: 'bulkUnsubscriptionStatus',
                queryValue: ''
            },
            {
                text: 'Processed At',
                type: 'date',
                value: 'bulkUnsubscriptionProcessedAt',
                queryValue: []
            }
        )
    }

    loadBulkUnsubscriptionList (sort: { sortBy: string; sortByDesc: boolean }) {
        this.sortBy = sort.sortBy
        this.sortByDesc = sort.sortByDesc
        this.loadData()
    }

    loadData () {
        this.loading = true
        this.filters.forEach((filter, i) => {
            if (filter.type === 'date') {
                filter.queryValue = this.dateFilter[i]
            }
        })

        this.$store
            .dispatch('getBulkUnsubscriptionPaginate', {
                page: this.pagination.currentPage,
                filters: this.filters,
                limit: this.rowsPerPage,
                sortBy: this.sortBy,
                sort: this.sortByDesc ? 'asc' : 'desc'
            })
            .then(resp => {
                if (resp?.status === 200) {
                    this.pagination = {
                        ...this.$store.state.BulkUnsubscriptionStore
                            .bulkUnsubscriptionsPaginate
                    }
                    this.data =
                        this.$store.state.BulkUnsubscriptionStore
                            .bulkUnsubscriptionsPaginate.results || []
                    if (this.pagination.results) delete this.pagination.results

                    if (!this.pagination?.currentPage) {
                        this.pagination.currentPage = 1
                    }

                    this.loading = false
                }
            })
    }

    async mounted () {
        this.columns.forEach(column => {
            if (column.customField) this.customColums.push(column)
        })
        this.getFilters()
        this.loadData()
    }
}
